import { Card, CardBody, CardHeader, CardHeaderActions, CardHeading, SwitchControl } from "@dgs/core";
import { Form, Formik } from "formik";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FeedbackAnalyticsContent } from "./FeedbackAnalyticsContent";

const StyledSwitchControl = styled(SwitchControl)`
	margin: 0;
`;

export const FeedbackAnalyticsPage: FC = () => {
	const { t } = useTranslation();
	const [compareEnabled, setCompareEnabled] = useState<boolean>(false);

	return (
		<Card>
			<CardHeader>
				<CardHeading>{t("Detailed analysis")}</CardHeading>
				<CardHeaderActions>
					<StyledSwitchControl
						name="showOnlyOwnEvents"
						label={t("Compare events")}
						value={compareEnabled}
						onChange={(e) => setCompareEnabled(e.target.value)}
					/>
				</CardHeaderActions>
			</CardHeader>
			<CardBody>
				<Formik initialValues={{ selectedEvent: null, eventToCompare: null }} onSubmit={() => void 0}>
					<Form>
						<FeedbackAnalyticsContent compareEnabled={compareEnabled} />
					</Form>
				</Formik>
			</CardBody>
		</Card>
	);
};
